import React from 'react';
import clsx from 'clsx';
import {useStyles} from './helper';

const PanelItem = ({label, labelCol, valueCol}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.wrapLabel}>
                <span className={classes.text}>{label}</span>
            </div>
            <div className={classes.wrapItems}>
                <div className={classes.wrapItem}>
                    <span className={clsx(classes.text, classes.w150)}>{labelCol.length &&labelCol[0] ? labelCol[0] : ''}:&nbsp;</span>
                    <span className={classes.text}>{new Intl.NumberFormat('ru-RU').format(valueCol[0])}</span>
                </div>
                <div  className={clsx(classes.wrapItem, classes.bg)}>
                   <span className={clsx(classes.text, classes.w150)}>{labelCol[1]}:&nbsp;</span>
                   <span className={classes.text}>{new Intl.NumberFormat('ru-RU').format(valueCol[1])}</span>
                </div>
                <div  className={classes.wrapItem}>
                    <span  className={clsx(classes.text, classes.w150)}>{labelCol[2]}:&nbsp;</span>
                    <span className={classes.text}>{new Intl.NumberFormat('ru-RU').format(valueCol[2])}</span>
                </div>
            </div> 
        </div>
    )
}

export default PanelItem;